var a=".",r={},t="xstate.guard",e="";export{t as DEFAULT_GUARD_TYPE,r as EMPTY_ACTIVITY_MAP,a as STATE_DELIMITER,e as TARGETLESS_KEY};
//# sourceMappingURL=constants.js.map
